<template>
  <main class="layout--default">
    <NuxtLoadingIndicator color="#bf3bd9" />
    <PageHeader :config="config" />
    <slot />
    <PageFooter :config="config" />

    <UModals />
  </main>
</template>

<script setup>
  const isPreview = useRuntimeConfig().public.CMS_ENV !== "production";

  const story = ref(null);

  if (isPreview) {
    const storyAsync = await useAsyncStoryblok("data/config", {
      version: "draft",
    });
    story.value = storyAsync.value;
  } else {
    const { data: storyAsyncData } = await useAsyncData("data/config", async () => {
      const storyData = await useAsyncStoryblok("data/config", {
        version: "published",
      });
      return storyData.value;
    });

    story.value = storyAsyncData.value;
  }

  const config = computed(() => story.value.content);
</script>
